import PropTypes from 'prop-types';
import React from 'react';

import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { Grid, GridColumn } from '@/design-system/atoms/Grid';

import styles from './ConditionsSearch.module.scss';

const ConditionsSearch = ({ heroContainer, leftContainer, rightContainer, ...props }) => {
    return (
        <div className={styles[`conditions-search`]} {...props}>
            <section className={styles[`conditions-search__hero`]}>
                {heroContainer && <div>{heroContainer}</div>}
            </section>
            <ContentContainer>
                <Grid className={styles[`conditions-search__grid`]}>
                    <GridColumn
                        colSpan={{ sm: 4, md: 6, lg: 8 }}
                        className={styles[`conditions-search__left-container`]}
                    >
                        {leftContainer && <div>{leftContainer}</div>}
                    </GridColumn>
                    <GridColumn
                        colSpan={{ sm: 4, md: 6, lg: 4 }}
                        className={styles[`conditions-search__right-container`]}
                    >
                        {rightContainer && <div>{rightContainer}</div>}
                    </GridColumn>
                </Grid>
            </ContentContainer>
        </div>
    );
};

ConditionsSearch.propTypes = {
    /**
     * Hero container
     */
    heroContainer: PropTypes.node,
    /**
     * Left container
     */
    leftContainer: PropTypes.node,
    /**
     * Right container
     */
    rightContainer: PropTypes.node,
};

export default ConditionsSearch;
